import { render, staticRenderFns } from "./data-upload.vue?vue&type=template&id=91b4f17a&"
import script from "./data-upload.vue?vue&type=script&lang=ts&"
export * from "./data-upload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports